/** Shared with Insights index and blog chrome (category jump links). */

export const BLOG_CATEGORY_ORDER = [
  "Founder",
  "FMCG",
  "Analytics",
  "Operations",
  "Retail",
  "Warehouse",
  "Supply chain",
  "Systems",
  "Risk",
  "Finance",
  "Strategy",
  "Compliance",
] as const;

/** URL segment for `/blog/category/[category]` — must stay stable for SEO. */
export function categoryPathSegment(category: string): string {
  return category.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
}

export function catAnchorId(category: string) {
  return `cat-${categoryPathSegment(category)}`;
}

export function categoryFromPathSegment(segment: string): string | null {
  for (const c of BLOG_CATEGORY_ORDER) {
    if (categoryPathSegment(c) === segment) return c;
  }
  return null;
}

export function sortCategories(cats: string[]) {
  const rank = (c: string) => {
    const i = BLOG_CATEGORY_ORDER.indexOf(c as (typeof BLOG_CATEGORY_ORDER)[number]);
    return i === -1 ? 999 : i;
  };
  return [...cats].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}
